import {applyMiddleware, legacy_createStore as createStore, Store} from 'redux';
import initialState from './state';
import reducers from './reducers';
import rootSaga from './_saga/sagas';
import middlewares, {sagaMiddleware} from './middlewares';

const store: Store = createStore(
	reducers,
	initialState,
	applyMiddleware(...middlewares)
);

sagaMiddleware.run(rootSaga);

export default store;
